import { Colorways, Margins } from 'types/constants';
import { cn, getColorway, getYMargins } from 'utils/styles';
import { Color } from 'libs/contentful/props';

export const carouselClassNames = (color: Colorways | Color, className?: string) =>
  cn('relative flex overflow-hidden', getColorway(color), className);

export const carouselContentClassNames = (margins: Margins, className?: string) =>
  cn('content-wrapper', getYMargins(margins), className);
